module.exports = __webpack_public_path__ + "img/bg.dfb094af.png";